import { Component, computed, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Enums } from '../../../shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class HeaderComponent implements OnInit {
    // #region [ViewChild]
    @ViewChild('floaterRef') floaterRef: ElementRef;
    // #endregion

    // #region [Type props]
    Enums = Enums;
    // #endregion

    // #region [props]
    tokenTimer: number = null;
    tokenTimerFormatted = '00:00';
    isLandingPage = false;
    // #endregion

    // #region [signals]
    $isAuthenticated = signal(false);
    $isHintModeOn = signal(false);
    $showAllHints = signal(false);
    // #endregion

    // #region [computeds]
    $showLogInButton = computed(() => this.isLandingPage && !this.$isAuthenticated());
    // #endregion

    constructor(
        private router: Router,
        private authService: AuthService
    ) {
        this.isLandingPage = window?.location?.pathname == Enums.PagesPaths.LandingPage;

        router.events.forEach(event => {
            if (event instanceof NavigationEnd) {
                const previous = this.floaterRef.nativeElement.style.transition;
                this.floaterRef.nativeElement.style.transition = 'left .4s ease-out';
                this.floaterRef.nativeElement.style.left = '-50px';
                setTimeout(() => this.floaterRef.nativeElement.style.transition = previous, 1);
            }
        });
    }

    async ngOnInit() {
        this.$isAuthenticated.set((await this.authService.getStatus()).data.isAuthenticated);

        setInterval(() => {
            const reference = document.querySelector('.hint-mode-reference');
            if (reference == null) return;

            const left = reference.getBoundingClientRect().left - 40;
            this.floaterRef.nativeElement.style.left = `${left}px`;
        }, 1000);
    }

    logIn() {
        this.router.navigate([Enums.PagesPaths.Home]);
    }

    toggleHintMode() {
        this.$isHintModeOn.set(!this.$isHintModeOn());
    }

    hintModeChange(event) {
        this.$isHintModeOn.set(event);
    }

    toggleShowAllHints() {
        this.$showAllHints.set(!this.$showAllHints());

        if (this.$showAllHints()) {
            let interval = setInterval(() => {
                if (!this.$showAllHints()) {
                    clearInterval(interval);
                    document.querySelectorAll('.hint-trigger').forEach((x: HTMLElement) => x.style.opacity = '');
                } else {
                    document.querySelectorAll('.hint-trigger').forEach((x: HTMLElement) => x.style.setProperty('opacity', '1', 'important'));
                }
            }, 750);
        } else {
            document.querySelectorAll('.hint-trigger').forEach((x: HTMLElement) => x.style.opacity = '');
        }
    }

    // #region [===== private methods =====]
    // #endregion
}
